import React, { useState, useContext } from "react";
import "./Showsub3.css";
import { Link } from "react-router-dom";
import { Training_details } from "../TrainingPage/Training_details/Training_datas";
import { contextData } from "../../App";

const MediaTrainingDropdown = ({ handleClose }) => {
  const [ind, setind] = useState(null);
  const context_data = useContext(contextData);
  let { handle } = context_data;

  function moving(index) {
    setind(index);
  }

  return (
    <ul className="drop_down_cont_media">
      {Training_details.map((item, index) => (
        <li key={index}>
          <Link
            className="drop_down_cont_media"
            to={`/training/${item.slug}`}
            onClick={() => {
              // handle(item, item.sub);
              moving(index);
              handleClose();
            }}
          >
            {item.title}
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default MediaTrainingDropdown;